import { render, staticRenderFns } from "./KxDatePicker.vue?vue&type=template&id=b82da9ca&"
import script from "./KxDatePicker.vue?vue&type=script&lang=js&"
export * from "./KxDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports